import { useMediaQuery } from "./useMediaQuery";

export const breakpoints = ["xs", "sm", "md", "lg", "xl", "2xl"] as const;

export type Breakpoint = (typeof breakpoints)[number];

type BreakpointMap = { [key in Breakpoint]: number };

const defaultBreakpoints: BreakpointMap = {
	xs: 0,
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	"2xl": 1536,
};

export function useBreakpoint(
	breakpoints: BreakpointMap = defaultBreakpoints
): Breakpoint {
	const isSm = useMediaQuery(`(min-width: ${breakpoints.sm}px)`);
	const isMd = useMediaQuery(`(min-width: ${breakpoints.md}px)`);
	const isLg = useMediaQuery(`(min-width: ${breakpoints.lg}px)`);
	const isXl = useMediaQuery(`(min-width: ${breakpoints.xl}px)`);
	const is2xl = useMediaQuery(`(min-width: ${breakpoints["2xl"]}px)`);

	if (is2xl) return "2xl";
	if (isXl) return "xl";
	if (isLg) return "lg";
	if (isMd) return "md";
	if (isSm) return "sm";
	return "xs";
}

const getReponsiveValue = (breakpoints: BreakpointMap) => ({
	sm: `(min-width: ${breakpoints.sm}px)`,
	md: `(min-width: ${breakpoints.md}px)`,
	lg: `(min-width: ${breakpoints.lg}px)`,
	xl: `(min-width: ${breakpoints.xl}px)`,
	"2xl": `(min-width: ${breakpoints["2xl"]}px)`,
});

export const useResponsiveMediaQuery = (
	breakpoint: Exclude<Breakpoint, "xs">,
	options?: {
		breakpoints?: BreakpointMap;
	}
) => {
	return useMediaQuery(
		getReponsiveValue(options?.breakpoints || defaultBreakpoints)[
			breakpoint
		]
	);
};
